import { useEffect, useRef } from 'react';

export const useScrollLock = (lock: boolean) => {
  const scrollPosition = useRef(0);

  useEffect(() => {
    // Only apply on desktop (min-width: 1025px)
    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1025;
    
    if (!isDesktop) return;

    if (lock) {
      // Capture scroll position
      scrollPosition.current = window.scrollY;
      
      // Apply lock styles
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition.current}px`;
      document.body.style.width = '100%';
      document.body.style.touchAction = 'none';
      document.body.style.overscrollBehavior = 'none';
    } else {
      // Restore styles
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.touchAction = '';
      document.body.style.overscrollBehavior = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollPosition.current);
    }

    return () => {
      if (lock && isDesktop) {
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.touchAction = '';
        document.body.style.overscrollBehavior = '';
        window.scrollTo(0, scrollPosition.current);
      }
    };
  }, [lock]);
};
